/* eslint-disable react/prop-types */
import React from "react"
import { RouteComponentProps } from "@reach/router"
import { DocumentTitleOverride } from "@shared/primitive-components"
import { IFrame } from "./iframe"
import { usePolicyAndFleet } from "../contexts"

type Props = RouteComponentProps<{
  vrn: string
}>

export const TripsVrn: React.FC<Props> = ({ vrn }) => {
  const { policy } = usePolicyAndFleet()

  return (
    <>
      <DocumentTitleOverride>Flock Motor | Vehicle Trips - {vrn}</DocumentTitleOverride>
      <IFrame path={`policies/${policy.id}/trips/${vrn}`} />
    </>
  )
}
